module.exports = __webpack_public_path__ + "img/thumbnail_KomodoDragon_f_normal.e450c42f.png";